import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css"

const perks = [
  {
    title: "🎉 Early Access",
    desc: "Get early access before public launch and be among the first to test real features and live battles.",
  },
  {
    title: "🕹️ Real-Time Testing",
    desc: "Experience the thrill of live, real-time dance battles before anyone else.",
  },
  {
    title: "📣 Feedback Influence",
    desc: "Your insights help shape the product direction and feature development.",
  },
  {
    title: "🏆 Exclusive Perks",
    desc: "Earn social shoutouts, referral rewards, and early access to premium features.",
  },
  {
    title: "📢 Be Heard",
    desc: "Your feedback directly impacts how Beats Fussion evolves.",
  },
  {
    title: "🚀 Limited Spots",
    desc: "Join the waitlist now to secure your spot in our first test group before it fills up.",
  },
];

const Perks = () => {
  useEffect (() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: true
    })
  }, [])

  return (
    <section className="bg-white py-16 px-4 sm:px-6 text-center" data-aos="fade-up">
    <h2 className="text-3xl font-bold text-purple-700 mb-6" data-aos="fade-down" data-aos-delay="100">Why Join the Beta?</h2>
    <p className="max-w-2xl mx-auto text-gray-600 mb-10 text-base sm:text-lg" data-aos="fade-up" data-aos-delay="200">
      Are you a dancer, a fan of live competition, or someone who loves discovering new talent? Beats Fussion is revolutionizing how dance battles are experienced — live, real-time, competitive, and fun. And we want <strong>YOU</strong> to help us test it before the world sees it.
    </p>
    <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3 max-w-6xl mx-auto text-left" data-aos="fade-up" data-aos-delay="300">
      {perks.map((perk, index) => (
        <div key={perk.title} className="bg-purple-50 p-6 rounded-lg shadow-md h-full" data-aos="zoom-in" data-aos-delay={400 + index * 100}>
          <h3 className="text-xl font-semibold mb-2">{perk.title}</h3>
          <p className="text-gray-700 text-base">{perk.desc}</p>
        </div>
      ))}
    </div>
  </section>
  )
};

export default Perks;
